import React from 'react';
import PropTypes from 'prop-types';

import NormalImageUploadField from '../../normal/ImageUploadField';

const propTypes = {
  input: PropTypes.shape({
    value: PropTypes.string,
    onChange: PropTypes.func,
  }).isRequired,
  meta: PropTypes.shape({
    error: PropTypes.string,
    touched: PropTypes.bool,
    invalid: PropTypes.bool,
  }).isRequired,
  tooltip: PropTypes.string,
};

const defaultProps = {
  tooltip: '',
};

const ImageUploadField = props => {
  const {
    input: { value, onChange, onBlur, onFocus },
    meta: { error, touched, invalid },
    tooltip,
    reference,
    ...otherProps
  } = props;

  return (
    <NormalImageUploadField
      value={value}
      onChange={onChange}
      onBlur={onBlur}
      onFocus={onFocus}
      errMsg={error}
      tooltip={tooltip}
      touched={touched}
      invalid={invalid}
      reference={reference}
      accept="image/*"
      {...otherProps}
    />
  );
};

ImageUploadField.propTypes = propTypes;
ImageUploadField.defaultProps = defaultProps;

export default ImageUploadField;
